<app-base-modal
  [title]="'Линейный график'"
  [modalMaxHeight]="'90vh'"
  [modalLargeMaxWidth]="'100vw'"
>
  @if (isLoading) {
    <app-loader/>
  }
  <app-line-chart-filters
    [lineChartDialogData]="lineChartDialogData"
    [isArticlePage]="isArticlePage"
    (updateChart)="updateChart($event)"
  />

  @if (chartComponent; as cmp) {
    <ng-container
      *ngComponentOutlet="cmp; inputs: {
        lineChartDialogData: lineChartDialogData,
        updateLineChartParams: updateLineChartParams,
        isArticlePage: isArticlePage
      }"
    />
  }
  <div class="buttons-container">
    <button
      mat-button
      color="warn"
      (click)="closeDialog('cancel')"
    >
      Закрыть
    </button>
  </div>
</app-base-modal>
